import { createEmptyContext } from '../../../utils/create-empty-context';
/**
 * Card wallet context will wrap all children components and be available as merged props
 */
export const MemberPaymentCardWalletContextInstance = createEmptyContext();
/**
 * Utility method to create `MemberPaymentCardWalletContext` object from `MemberPaymentCardWalletProps`.
 */
export function mapMemberPaymentCardWalletContext(memberPaymentCardWalletProps, onCardAdded) {
    const { displayText, assets, config, events } = memberPaymentCardWalletProps;
    return { displayText, assets, config, events, onCardAdded };
}
